import { Box, Flex, Spinner, useColorModeValue, Text } from "@chakra-ui/react";
import { useState } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useJsApiLoader,
} from "@react-google-maps/api";
import { useMap } from "hooks/MapHook";
import { useQuery } from "react-query";

interface FilterMapProps {
  nome?: string;
  documento?: string;
  cidade?: string;
}

export default function Map(parms: FilterMapProps) {
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [mapCenter, setMapCenter] = useState({
    lat: -29.9372897,
    lng: -51.0817008,
  });
  const boxBg = useColorModeValue("#ffff", "#111c44");
  const textColor = useColorModeValue("#111c44", "#111c44");
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyBbXITuVbb6s6kJfVQBQ-h932D2-OmdemE",
  });
  const { findClientsMap } = useMap();
  const { data, isLoading } = useQuery(["findClientsMap", parms], () =>
    findClientsMap(parms)
  );

  const handleMarkerClick = (marker: any) => {
    setSelectedMarker(marker);
  };

  const handleInfoWindowClose = () => {
    setSelectedMarker(null);
  };

  return (
    <Flex
      direction="column"
      py={{ base: "10px", md: "16px" }}
      px={{ base: "10px", md: "14px" }}
    >
      {isLoading || !isLoaded ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="50vh"
          borderRadius="30px"
          backgroundColor={boxBg}
        >
          <Spinner width={120} height={120} />
        </Box>
      ) : (
        <GoogleMap
          mapContainerStyle={{
            width: "100%",
            height: "50vh",
            borderRadius: "30px",
          }}
          center={mapCenter}
          zoom={10}
          onCenterChanged={() => {
            if (!selectedMarker) {
              setMapCenter(mapCenter);
            }
          }}
        >
          {data.map((marker) => (
            <Marker
              key={marker.ID}
              position={{
                lat: parseFloat(marker.LATITUDE),
                lng: parseFloat(marker.LONGITUDE),
              }}
              title={marker.NOME}
              onClick={() => handleMarkerClick(marker)}
            />
          ))}

          {selectedMarker && (
            <InfoWindow
              position={{
                lat: parseFloat(selectedMarker.LATITUDE),
                lng: parseFloat(selectedMarker.LONGITUDE),
              }}
              onCloseClick={handleInfoWindowClose}
            >
              <Box color={textColor}>
                <Text>Razão social: {selectedMarker.NOME}</Text>
                <Text>Nome fantasia: {selectedMarker.NOME_FANTASIA}</Text>
              </Box>
            </InfoWindow>
          )}
        </GoogleMap>
      )}
    </Flex>
  );
}
